const serverConfig = {
  baseURL: "https://www.skychems.com/shangqinapi", // 请求基础地址,可根据环境自定义
  imgIpURL: "http://www.skychems.com/",
  useTokenAuthorization: false, // 是否开启 token 认证
}
export default serverConfig


// WEBPACK FOOTER //
// ./src/http/config/index.js